import { useCallback } from 'react';
import { useTriggerCaseSync } from '@hooks/react-query/mutations/useTriggerCaseSync';
import { Button, useToast } from 'ui';
import { useAuth } from '@context/AuthContext';
import { useUserOrgCase } from '@context/UserOrgCaseContext';
import { StyledSyncIcon } from './SyncCaseButton.styles';

const SYNC_CONFLICT_STATUS = 409;

export function SyncCaseButton() {
  const { displayToaster } = useToast();
  const { selectedCase } = useUserOrgCase();
  const { isSuperAdmin } = useAuth();

  const { mutateAsync: triggerCaseSync, isPending } = useTriggerCaseSync();

  const handleSyncCaseClick = useCallback(async () => {
    try {
      await triggerCaseSync({
        caseIDs: [selectedCase.caseID],
      });
      displayToaster('Sync started successfully', 'success');
    } catch (error) {
      const status = (error as { response?: { status?: number } })?.response
        ?.status;
      if (status === SYNC_CONFLICT_STATUS) {
        displayToaster('Sync already in progress for this case.', 'error');
        return;
      }
      displayToaster('Sync could not be started.', 'error');
    }
  }, [displayToaster, selectedCase, triggerCaseSync]);

  if (!isSuperAdmin || !selectedCase?.caseID) return null;

  return (
    <Button
      aria-label="Sync Case"
      color="neutral"
      disabled={isPending}
      onClick={handleSyncCaseClick}
      startIcon={<StyledSyncIcon isSpinning={isPending} />}
      variant="text"
    />
  );
}
